// Search-param schema for the card-browser routes (`/cards`, `/cards/$`).
// Lives in its own dependency-free module so the ROUTE STUBS can import it:
// importing a runtime value from the page module defeats the router's
// component code-splitting and drags the entire catalog browser tree into the
// entry chunk.

export type CategorySearch = {
  /** Absent = "recommended" (the PRD 04 default). */
  sort?: "popular" | "recent";
  premium?: "free" | "premium";
  type?: string;
  q?: string;
  /** Legacy `?explainer=` popup trigger — opens the gift-card explainer once, then stripped. */
  explainer?: string;
};

/** Shared by the `/cards` (root) and `/cards/$` (category) routes. */
export const validateCatalogSearch = (search: Record<string, unknown>): CategorySearch => ({
  sort: search.sort === "recent" ? "recent" : search.sort === "popular" ? "popular" : undefined,
  premium: search.premium === "free" || search.premium === "premium" ? search.premium : undefined,
  type: typeof search.type === "string" && search.type ? search.type : undefined,
  q: typeof search.q === "string" && search.q ? search.q : undefined,
  explainer: search.explainer ? String(search.explainer) : undefined,
});
